import React, { lazy, Suspense } from "react";
import styled from "styled-components";
import { Bio } from "../../data/constants";
import Typewriter from "typewriter-effect";
import { heroContentVariants } from "../../utils/motion";
import { motion } from "framer-motion";
import { useLoaderComplete } from "../../utils/useLoaderComplete";
import './Hero.css';
import AuroraBackground from "../AuroraBackground";

const StatueCanvas = lazy(() => import("../canvas/Statue"));

const HeroContainer = styled.div`
  position: relative;
  isolation: isolate;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  min-height: 100svh;
  min-height: 100dvh;
  width: 100%;
  padding: 0 var(--page-x) calc(32px + var(--safe-bottom));
  text-align: center;
  overflow: hidden;
`;

const Title = styled.div`
    position: relative;
    z-index: 1;
    text-align: center;
    color: ${({ theme }) => theme.text_primary};
    user-select: none;
`;

const Bottom = styled.div`
  position: relative;
  z-index: 4;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: clamp(16px, 4vh, 40px);
  width: 100%;
`;

const TextLoop = styled.div`
  font-size: clamp(1.25rem, 5vw, 3rem);
  text-align: center;
  font-weight: 400;
  color: ${({ theme }) => theme.text_primary};
  width: 100%;
  user-select: none;
`;

const Span = styled.div`
  cursor: pointer;
  color: ${({ theme }) => theme.primary};
`;


const ResumeButton = styled.a`
  position: static;
  z-index: 4;
  min-height: 48px;
  font-size: 15px;
  text-transform: uppercase;
  font-weight: 900;
  text-align: center;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 50px;
  cursor: pointer;
  padding: 14px 30px;
  transition: all 0.4s ease-in-out;
  text-decoration: none;
  font-family: "Syncopate", sans-serif;
  border: 1px solid ${({ theme }) => theme.text_primary};
  color: ${({ theme }) => theme.text_primary};

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.text_primary};
    outline-offset: 4px;
  }

  @media (hover: hover) {
    &:hover {
      background: ${({ theme }) => theme.text_primary};
      color: ${({ theme }) => theme.bg};
    }
  }
`;

const HaloCanvasContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 3;
  width: min(90%, 760px);
  height: 65%;
  pointer-events: none;

  @media (max-width: 768px) {
    width: 80%;
    height: 55%;
  }
`;


const HeadlineContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  margin-top: 200px;
`;


const Hero = () => {
  const loaderComplete = useLoaderComplete();
  const contentMotion = {
    variants: heroContentVariants,
    initial: "hidden",
    animate: loaderComplete ? "visible" : "hidden",
  };

  return (
    <div id="Home">
       <motion.div {...contentMotion}>
      <HeroContainer >
        <AuroraBackground />
        <HaloCanvasContainer>
          <Suspense fallback={null}>
            <StatueCanvas />
          </Suspense>
        </HaloCanvasContainer>

        <HeadlineContainer>
          <Title id="text-behind" >{Bio.name}</Title>
          <Title id="text-behind-blur">{Bio.name}</Title>
          <Title id="text-front">{Bio.name}</Title>
        </HeadlineContainer>

        <Bottom>
          <TextLoop>
              <Span>
                <Typewriter
                  options={{
                    strings: Bio.roles,
                    autoStart: true,
                    loop: true,
                  }}
                />
              </Span>
            </TextLoop>

          <ResumeButton href={Bio.resume} target="_blank" rel="noopener noreferrer">
            Resume
          </ResumeButton>
        </Bottom>

      </HeroContainer>
      </motion.div>
    </div>
  );
};

export default Hero;
